import React from "react";
import { Button, Modal } from "react-bootstrap";
import Fontstyling from "../comman";

export const ConfirmModal = ({ show, closeModal, ifYes, massage }) => {
  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Are you sure?</Modal.Title>
      </Modal.Header>
      <Modal.Body>{massage}</Modal.Body>
      <Modal.Footer>
        <Button
          style={Fontstyling.savebutton}
          onClick={ifYes}
        >
          Yes
        </Button>
        <Button
          style={Fontstyling.cancelbutton}
          onClick={closeModal}
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
